module.exports = __webpack_public_path__ + "static/media/download.e492cf9a.svg";